import { useCallback } from 'react';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useFormState } from 'modules/taboola-common-frontend-modules/forms';
import { useMultiLayerPathParams } from 'modules/taboola-common-frontend-modules/multi-layer-drawer/hooks/useMultiLayerPathParams';
import { useLandingPagesApi } from 'services/api/landingPagesApi';
import { LANDING_PAGES_ROUTE } from '../config';
import { INITIAL_CHAT_STATE } from '../consts/chatState';
import { useHandleChatSubmit } from './useHandleChatSubmit';
import { useHandlePublish } from './useHandlePublish';

export const useLandingPageEditorState = () => {
    const { getLandingPage } = useLandingPagesApi();
    const chatSubmitHandler = useHandleChatSubmit();
    const publishHandler = useHandlePublish();
    const { landingPageId } = useMultiLayerPathParams();
    const { accountName } = useAccount();

    // Create a callback for fetching landing page data
    const formDataFetcher = useCallback(async () => {
        const landingPage = await getLandingPage({ accountName, landingPageId });
        return {
            ...landingPage,
            landingPageId,
            chatHistory: INITIAL_CHAT_STATE,
        };
    }, [accountName, landingPageId, getLandingPage]);

    // Use the formState hook to manage data fetching and state
    const { submit, submitStep } = useFormState({ formDataFetcher, waitAccountFetched: true });

    // Create a submit wrapper that handles publishing
    const handleSubmitWrapper = useCallback(
        () => submit(publishHandler, LANDING_PAGES_ROUTE),
        [submit, publishHandler]
    );

    const handleSubmitStepWrapper = useCallback(() => submitStep(chatSubmitHandler), [submitStep, chatSubmitHandler]);

    return {
        submit: handleSubmitWrapper,
        submitStep: handleSubmitStepWrapper,
    };
};
